import instance from "../common/Api";
import "./Cookies.css";
import React, { useEffect, useState } from "react";
import Loader from "../common/Loader";

const AboutUs = () => {
  const [htmlContent, setHtmlContent] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    instance.get("/getPage/1").then((response) => {
      let data = response.data.description;

      // Ensure data is a string
      if (typeof data !== "string") {
        data = JSON.stringify(data);
      }
      const tagsToColorGreen = ["h3", "h2", "h1"]; // Add more tags if needed
      // Set the HTML content and manipulate it to set text color to green for specified tags
      let modifiedHtmlContent = data;
      tagsToColorGreen.forEach((tag) => {
        modifiedHtmlContent = modifiedHtmlContent.replace(
          new RegExp(`<${tag}(.*?)>`, "g"),
          `<${tag} style="color: #58b7aa;"$1>`
        );
      });
      setLoading(false);
      setHtmlContent(modifiedHtmlContent);
    });
  }, []);

  return (
    <div
      className="container-fluid privacyPolicyImgbox"
      style={{
        width: "100%",
        minHeight: "51rem",
        position: "relative",
        backgroundBlendMode: "overlay",
      }}
    >
      {loading && (
        <div className="loading-overlay">
          <Loader isLoading={loading} />
        </div>
      )}
      <div className="container privacyPolicyBellowTextBox">
        <div id="scroll">
          <div className="row">
            {htmlContent && (
              <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
            )}
          </div>
        </div>
      </div>
    </div>
    // <div
    //   className="container-fluid privacyPolicyImgbox"
    //   style={{
    //     width: "100%",
    //     minHeight: "51rem",
    //     position: "relative",
    //     // backgroundImage: `url(./bebuAppBG.JPEG)`,
    //     // backgroundSize: "cover",
    //     // backgroundPosition: "center",
    //     // backgroundColor: 'transperent',
    //     backgroundBlendMode: "overlay",
    //   }}
    // >
    //   <div className="container privacyPolicyBellowTextBox">
    //     <div id="scroll">
    //       <div className="row">
    //         <div className="col-md-12 privacyContentBox">
    //           <h3
    //             style={{
    //               color: "white",
    //               paddingBottom: "10px",
    //               paddingTop: "50px",
    //             }}
    //           >
    //             ABOUT US
    //           </h3>
    //           <p>
    //             Weekend binges just got better! Bebu is the latest entertainment
    //             hub, built to get your heart racing. Watch the best of drama,
    //             comedy, romance and much more on the Bebu. Stream online on
    //             www.bebu.app We are certain you will love our original
    //             programming of Short Films and Web Series. The best part is you
    //             can try before you buy!
    //           </p>
    //           <div style={{ paddingLeft: "50px" }}>
    //             <p>• Content in local languages</p>
    //             <p>• Unlimited and Uninterrupted Video Streaming</p>
    //             <p>• Offline in-app Download available</p>
    //             <p>• Easy & flexible pricing</p>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </div>
  );
};

export default AboutUs;
